import {
	RESET_CURRENT_TEAMS,
	SAVE_TEAM,
	SAVE_TEAM_COMPLETE,
	SET_CURRENT_TEAMS,
	SET_CURRENT_TEAMS_COMPLETE
} from "./constants";

const initialState = {
	isLoading: false,
	teams: [],
	homeTeam: null,
	awayTeam: null
};

const reducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case SET_CURRENT_TEAMS:
		case SAVE_TEAM:
			return { ...state, ...payload, isLoading: true };
		case SET_CURRENT_TEAMS_COMPLETE:
		case RESET_CURRENT_TEAMS:
			return { ...state, ...payload, isLoading: false };
		case SAVE_TEAM_COMPLETE: {
			const { savedTeam } = payload;
			if (state.teams) {
				state.teams.forEach((t) => {
					if (t.id === savedTeam.id) {
						Object.assign(t, savedTeam);
					}
				});
			}
			return {
				...state,
				homeTeam: state.homeTeam.id === savedTeam.id ? savedTeam : state.homeTeam,
				awayTeam: state.awayTeam.id === savedTeam.id ? savedTeam : state.awayTeam,
				isLoading: false
			};
		}
		default:
			return state;
	}
};

export default reducer;
